import { useState } from 'react';
import './ui.css';

interface SecretFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  /** when set, the secret exists server-side: render a masked chip + Replace button */
  last4?: string | null;
  multiline?: boolean;
  placeholder?: string;
}

/**
 * Write-only secret input. The server never returns secret material — only
 * last4. When last4 is present we show a masked row; "Replace" reveals an
 * empty input bound to `value`/`onChange`.
 */
export function SecretField({
  id,
  label,
  value,
  onChange,
  last4,
  multiline = false,
  placeholder,
}: SecretFieldProps) {
  const [replacing, setReplacing] = useState(false);

  if (last4 && !replacing) {
    return (
      <div className="field">
        <label htmlFor={`${id}-replace`}>{label}</label>
        <div className="secret-existing">
          <span className="mono secret-mask" aria-hidden="true">
            ••••••••••••
          </span>
          <span className="mono secret-last4">…{last4}</span>
          <button
            id={`${id}-replace`}
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => {
              setReplacing(true);
              onChange('');
            }}
          >
            Replace
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      {multiline ? (
        <textarea
          id={id}
          className="mono secret-textarea"
          rows={6}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete="off"
          spellCheck={false}
        />
      ) : (
        <input
          id={id}
          type="password"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete="new-password"
        />
      )}
    </div>
  );
}
